"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = require("../../styles");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InvertingButton = function InvertingButton(_ref) {
  var children = _ref.children,
      outlineColor = _ref.outlineColor,
      backgroundColor = _ref.backgroundColor,
      onClick = _ref.onClick,
      customLoader = _ref.customLoader,
      props = _objectWithoutProperties(_ref, ["children", "outlineColor", "backgroundColor", "onClick", "customLoader"]);

  return _react["default"].createElement(_Button["default"], _extends({
    onClick: onClick,
    customLoader: customLoader || _react["default"].createElement(_Loader["default"], {
      scale: 0.5,
      color: outlineColor
    })
  }, props), children);
};

InvertingButton.propTypes = {
  /** children for the Inverting Button */
  children: _propTypes["default"].node,

  /** Outline color for the button */
  outlineColor: _propTypes["default"].string,

  /** Background color for the button */
  backgroundColor: _propTypes["default"].string,

  /** Button onClick callback */
  onClick: _propTypes["default"].func,

  /** Bool flag to enable/disable the button */
  disabled: _propTypes["default"].bool,

  /** A loading button is auto-disabled and displays a spinning loader */
  loading: _propTypes["default"].bool,

  /** Provide a customized loader element if necessary */
  customLoader: _propTypes["default"].element
};
InvertingButton.defaultProps = {
  children: null,
  outlineColor: _styles.colors.blue,
  backgroundColor: _styles.colors.white,
  onClick: function onClick() {},
  loading: false,
  customLoader: null
};

var _default = (0, _withStyles["default"])(_styles2["default"])(InvertingButton);

exports["default"] = _default;